import LoginTypes from './login.types';

export const loginStart = (data: any) => ({
	type: LoginTypes.LOGIN_START,
	payload: data,
});

export const loginSuccess = (data: any) => ({
	type: LoginTypes.LOGIN_SUCCESS,
	payload: data,
});

export const loginFailure = (error: unknown) => ({
	type: LoginTypes.LOGIN_FAILURE,
	payload: error,
});

export const loginResponseChanged = () => ({
	type: LoginTypes.LOGIN_RESPONSE_CHANGED,
});

export const loginResponseRestStart = () => ({
	type: LoginTypes.LOGIN_RESPONSE_REST_START,
});

export const addPersistDataStart = (loginData: any) => ({
	type: LoginTypes.PERSIST_LOGIN_DATA_START,
	payload: loginData,
});
